import type { PaymentIntent } from '@chargebee/chargebee-js-react-wrapper';
import Axios from 'axios';
import { API_URL } from '../../../app-config/constants';
import type CheckoutRequest from '../../../types/CheckoutRequest';
import type CheckoutResponse from '../../../types/CheckoutResponse';
import type CustomerDto from '../../../types/CustomerDto';
import type { BillingContact, BillingDetails } from '../../../types/CustomerDto';
import type { Estimate } from '../../../types/Estimate';
import type { EndSubscriptionForm } from '../../react/features/Billing/types';
import { get, post, put, remove } from '../request';

// -- End user facing -- //

const BASE_URL = `${API_URL}/your-billing`;

export function estimate(checkoutRequest: CheckoutRequest): Promise<CheckoutResponse> & { cancel(): void } {
    const source = Axios.CancelToken.source();
    const promise = Axios.post<CheckoutResponse>(`${BASE_URL}/estimate`, checkoutRequest, {
        cancelToken: source.token,
    }).then(
        r => r.data,
        err => {
            if (Axios.isCancel(err)) {
                // Return a Promise that never resolves
                return new Promise(() => {});
            } else {
                return Promise.reject(err);
            }
        }
    );
    Object.defineProperty(promise, 'cancel', {
        value: () => {
            source.cancel();
        },
    });

    return promise as any;
}

export function previewRenewal() {
    return post<Estimate>(`${BASE_URL}/preview-renewal`);
}

setBillingDetails.operation = 'COMMAND';
export function setBillingDetails(billingDetails: BillingDetails) {
    return put<CustomerDto>(`${BASE_URL}/billing-details`, { postData: billingDetails });
}

getCustomer.operation = 'READ';
export function getCustomer() {
    return get<CustomerDto>(`${BASE_URL}`);
}

checkout.operation = 'COMMAND';
export function checkout(request: CheckoutRequest) {
    return post<CustomerDto>(`${BASE_URL}/checkout`, { postData: request });
}

checkout.operation = 'COMMAND';
export function createPaymentIntent(amount: number) {
    return post<PaymentIntent>(`${BASE_URL}/payment-intent`, { postData: amount });
}

removeCard.operation = 'COMMAND';
export function removeCard() {
    return remove(`${BASE_URL}/card`);
}

endSubscription.operation = 'COMMAND';
export function endSubscription(data: EndSubscriptionForm) {
    return post(`${BASE_URL}/end-subscription`, { postData: data });
}

addBillingContact.operation = 'COMMAND';
export function addBillingContact(billingContact: BillingContact): Promise<CustomerDto> {
    return post(`${BASE_URL}/billing-contacts`, { postData: billingContact });
}

removeBillingContact.operation = 'COMMAND';
export function removeBillingContact(billingContactId: string): Promise<CustomerDto> {
    return remove(`${BASE_URL}/billing-contacts/${billingContactId}`);
}
